import { RouteConfig } from "vue-router";
import VError404 from "./VError404.vue";

export const RError404: RouteConfig = {
  path: "*",
  component: VError404,
  meta: {
    is404: true,
  },
};
